<script setup lang="ts">
import { SancareOcticon } from '@sancare/typescript-commons'
import { computed, nextTick, ref, watch } from 'vue'

import { useStore } from '@/store'
import { Stay } from '@/store/modules/stay/types'

const props = defineProps<{
  stay: Stay
}>()

const emit = defineEmits<{
  (e: 'comment-stay', comment: string, stayId: number | string): void
}>()

const commentEditing = ref('')
const isEditing = ref(false)
const formOpen = ref(false)
const commentTextarea = ref<HTMLTextAreaElement | null>(null)

const comment = computed(() =>
  props.stay.comment && props.stay.comment.length > 0
    ? props.stay.comment
    : 'Aucun commentaire'
)

const stayComment = computed(() =>
  props.stay.comment ? props.stay.comment : ''
)

watch(comment, function() {
  formOpen.value = isEditing.value = false
})

function commentStay() {
  if (commentEditing.value === comment.value) {
    formOpen.value = false
    return
  }
  isEditing.value = true
  emit('comment-stay', commentEditing.value, props.stay.id)
}

async function edit() {
  if (formOpen.value) return
  commentEditing.value = stayComment.value
  formOpen.value = true
  await nextTick()
  commentTextarea.value?.focus()
}
</script>

<template>
  <div>
    <div class="btn-divided btn-divided-mco row g-0 align-items-center">
      <div
        class="col-auto py-2 px-3 text-center cursor_default btn-divided__action"
        @click="edit"
      >
        <sancare-octicon name="comment" />
      </div>
      <div class="col py-2 px-3">
        Commentaire du séjour
      </div>
    </div>

    <div
      v-show="!formOpen"
      class="mt-2 g-0"
    >
      <div class="border col">
        <div
          class="comment-displayer"
          @click="edit"
        >
          {{ comment }}
        </div>
      </div>
    </div>

    <div
      v-show="formOpen"
      class="mt-3 g-0 align-items-center"
    >
      <textarea
        ref="commentTextarea"
        v-model="commentEditing"
        type="text"
        placeholder="Votre commentaire..."
        maxlength="5000"
        class="col comment-area p-1 w-100"
      />
      <div class="mt-1 row g-0">
        <button
          class="btn btn-danger col me-1"
          @click="formOpen = false"
        >
          Annuler
        </button>
        <button
          :disabled="isEditing"
          class="btn btn-primary col ms-1"
          @click="commentStay"
        >
          Enregistrer
        </button>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.cursor_default {
  cursor: default;
}

.comment-area {
  min-height: 7rem;
}

.comment-displayer {
  min-height: 1rem;
  max-height: 10rem;
  overflow: scroll;
  white-space: pre-wrap;
  padding: .3rem .3rem;
}
</style>
